/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Offline_Mode_BadgeInputs */

const en_login_offline_mode_badge = /** @type {(inputs: Login_Offline_Mode_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline Mode`)
};

const fr_login_offline_mode_badge = /** @type {(inputs: Login_Offline_Mode_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode Hors Ligne`)
};

const de_login_offline_mode_badge = /** @type {(inputs: Login_Offline_Mode_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline-Modus`)
};

const it_login_offline_mode_badge = /** @type {(inputs: Login_Offline_Mode_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modalità offline`)
};

const ru_login_offline_mode_badge = /** @type {(inputs: Login_Offline_Mode_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автономный режим`)
};

const es_login_offline_mode_badge = /** @type {(inputs: Login_Offline_Mode_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modo sin conexión`)
};

const zh_cn2_login_offline_mode_badge = /** @type {(inputs: Login_Offline_Mode_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`离线模式`)
};

const ja_login_offline_mode_badge = /** @type {(inputs: Login_Offline_Mode_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オフラインモード`)
};

const hi_login_offline_mode_badge = /** @type {(inputs: Login_Offline_Mode_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफ़लाइन मोड`)
};

const pt_pt2_login_offline_mode_badge = /** @type {(inputs: Login_Offline_Mode_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modo offline`)
};

/**
* | output |
* | --- |
* | "Offline Mode" |
*
* @param {Login_Offline_Mode_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_mode_badge = /** @type {((inputs?: Login_Offline_Mode_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Mode_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_offline_mode_badge(inputs)
	if (locale === "de") return de_login_offline_mode_badge(inputs)
	if (locale === "it") return it_login_offline_mode_badge(inputs)
	if (locale === "ru") return ru_login_offline_mode_badge(inputs)
	if (locale === "es") return es_login_offline_mode_badge(inputs)
	if (locale === "zh-CN") return zh_cn2_login_offline_mode_badge(inputs)
	if (locale === "ja") return ja_login_offline_mode_badge(inputs)
	if (locale === "hi") return hi_login_offline_mode_badge(inputs)
	if (locale === "pt-PT") return pt_pt2_login_offline_mode_badge(inputs)
	return en_login_offline_mode_badge(inputs)
});